/* Fecha de entrega estimada (Carlota Maré).
   Mismo plazo que el método de envío del checkout: 6 a 12 días laborables, sin sábados, domingos ni festivos
   nacionales. Rellena cualquier elemento con [data-cm-eta]:
   - data-cm-eta-prefix="Texto "  → "Texto entre el 8 y el 16 de octubre"
   - data-cm-eta-short             → "8-16 de octubre" (resumen del carrito)
   Sin días de la semana abreviados: "mar" (martes) se leía como "marzo".
   Si se cambia el plazo en Shopify (Envíos), cambiar MIN y MAX aquí. Festivos: añadir los de 2028 antes de 2028.
   SHOW_DATES = false (decisión 2-oct-2026): con 6-12 laborables las fechas quedaban muy lejanas (11-19 días
   naturales), así que se deja el texto del tema: "Entrega en 6 a 12 días laborables". Poner true para volver a fechas. */
(function () {
  var SHOW_DATES = false;
  if (!SHOW_DATES || window.cmEtaInit) return;
  window.cmEtaInit = true;

  var MIN = 6, MAX = 12;
  var HOLIDAYS = [
    '2026-10-12', '2026-11-01', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-01-06', '2027-03-26', '2027-05-01', '2027-08-15',
    '2027-10-12', '2027-11-01', '2027-12-06', '2027-12-08', '2027-12-25'
  ];
  var MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function key(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function isWorkday(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) < 0;
  }
  function addWorkdays(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    var count = 0;
    while (count < n) {
      d.setDate(d.getDate() + 1);
      if (isWorkday(d)) count++;
    }
    return d;
  }
  var from = addWorkdays(MIN), to = addWorkdays(MAX);
  var sameMonth = from.getMonth() === to.getMonth();
  var m1 = MONTHS[from.getMonth()], m2 = MONTHS[to.getMonth()];
  var longText = sameMonth
    ? 'entre el ' + from.getDate() + ' y el ' + to.getDate() + ' de ' + m2
    : 'entre el ' + from.getDate() + ' de ' + m1 + ' y el ' + to.getDate() + ' de ' + m2;
  var shortText = sameMonth
    ? from.getDate() + '-' + to.getDate() + ' de ' + m2
    : from.getDate() + ' ' + m1.slice(0, 3) + ' – ' + to.getDate() + ' ' + m2.slice(0, 3);

  function fill() {
    var els = document.querySelectorAll('[data-cm-eta]:not([data-cm-eta-done])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-cm-eta-done', '');
      if (el.hasAttribute('data-cm-eta-short')) {
        el.textContent = shortText;
      } else {
        el.textContent = el.getAttribute('data-cm-eta-prefix') || '';
        var strong = document.createElement('strong');
        strong.textContent = longText;
        el.appendChild(strong);
      }
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; fill(); });
  }

  function start() {
    fill();
    // El carrito y la notificación "Añadido a la cesta" se vuelven a pintar sin recargar la página.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();